export * from './vanilla/index';
//# sourceMappingURL=vanilla.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uirouter/core/lib-esm/vanilla.js
// module id = 106
// module chunks = 0